var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orders-table-empty"},[_c('icons-empty-recent-orders',{attrs:{"color":"#D8F1E4"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }